import { render, staticRenderFns } from "./private-sale-categories.vue?vue&type=template&id=08110b85&"
import script from "./private-sale-categories.vue?vue&type=script&lang=js&"
export * from "./private-sale-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports